import { render } from "./DynamicLoading.vue?vue&type=template&id=0bd6b767&ts=true"
import script from "./DynamicLoading.vue?vue&type=script&lang=ts"
export * from "./DynamicLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__